const { gql } = require('@apollo/client');

export const QUERY_FEATURES_AVAILABILITY = gql`
  query Devices {
    devices {
      featureAvailable
      eligibleToTunnel
    }
  }
`;

export const QUERY_ALL_DEVICES = gql`
  query Devices {
    devices {
      all {
        Name
        Scode
        IsActive
        APITunnel {
          Token
          Address
        }
        AccessCookie {
          JWTCookie
          FullCookie
          ExpirationDate
        }
      }
    }
  }
`;

export const QUERY_MAIN_DEVICE = gql`
  query Devices {
    devices {
      me {
        Name
        Scode
        IsActive
        APITunnel {
          Token
          Address
        }
        AccessCookie {
          JWTCookie
          FullCookie
          ExpirationDate
        }
      }
    }
  }
`;

export const QUERY_DEVICE_BY_SCODE = gql`
  query Devices($name: String!, $scode: String!) {
    devices {
      get(name: $name, scode: $scode) {
        Name
        Scode
        IsActive
        APITunnel {
          Token
          Address
        }
        AccessCookie {
          JWTCookie
          FullCookie
          ExpirationDate
        }
      }
    }
  }
`;

export const MUTATION_SET_DEVICE_TUNNEL_STATUS = gql`
  mutation Devices($isTunneled: Boolean!) {
    devices {
      setTunnelStatus(isTunneled: $isTunneled)
    }
  }
`;

export const MUTATION_SET_DEVICE_ADMIN_STATUS = gql`
  mutation Devices($isAdmin: Boolean!) {
    devices {
      setAdminStatus(isAdmin: $isAdmin)
    }
  }
`;
